import { AlertTriangle, CheckCircle2, Info } from 'lucide-react';

type Tone = 'error' | 'success' | 'info';

const config: Record<Tone, { classes: string; icon: typeof Info }> = {
  error: { classes: 'bg-red-50 text-red-700 border-red-200', icon: AlertTriangle },
  success: { classes: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: CheckCircle2 },
  info: { classes: 'bg-blue-50 text-blue-700 border-blue-200', icon: Info },
};

export function Alert({ tone = 'info', children }: { tone?: Tone; children: React.ReactNode }) {
  const { classes, icon: Icon } = config[tone];
  return (
    <div className={`flex items-start gap-2 rounded-lg border px-3.5 py-2.5 text-sm ${classes}`}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" />
      <div>{children}</div>
    </div>
  );
}
